if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      const variantInput = this.form.querySelector('[name=id]');
      if (variantInput) variantInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const stickyAtcVariantId = this.getStickyAtcVariantId();
      if (stickyAtcVariantId) formData.set('id', stickyAtcVariantId);
      if (this.cart) {
        //formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        //formData.append('sections_url', window.location.pathname);
        //this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      try {
        const response = await fetch(`${routes.cart_add_url}`, config);
        const responseJson = await response.json();

        if (responseJson.status) {
          this.handleErrorMessage(responseJson.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        }

        this.error = false;
        const stickyAtcDiscountCode = this.getStickyAtcDiscountCode();
        await this.applyStickyAtcDiscountCode(stickyAtcDiscountCode);

        if (!this.cart) {
          window.location = stickyAtcDiscountCode
            ? `${window.routes.cart_url}?discount=${encodeURIComponent(stickyAtcDiscountCode)}`
            : window.routes.cart_url;
          return;
        }

        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { window.CartDrawer.refresh() });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          window.CartDrawer.refresh();
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }
    }

    getStickyAtcDiscountCode() {
      const stickyAtc = this.closest('sticky-atc');
      const selectedOption = stickyAtc?.querySelector('[data-sticky-atc-select]')?.selectedOptions?.[0];
      return selectedOption?.dataset.discountCode?.trim() || stickyAtc?.dataset.stickyAtcDiscountCode?.trim() || '';
    }

    getStickyAtcVariantId() {
      return this.closest('sticky-atc')?.querySelector('[name="id"]')?.value?.trim() || '';
    }

    async applyStickyAtcDiscountCode(discountCode) {
      if (!discountCode) return;

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            discount: discountCode,
            discounts: discountCode,
          }),
        });

        if (!response.ok) {
          throw new Error(`Unable to apply discount code "${discountCode}"`);
        }

        await response.json();
      } catch (error) {
        console.error(error);

        try {
          await fetch(
            `${window.Shopify.routes.root}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent('/cart')}`,
            {
              method: 'GET',
              credentials: 'same-origin',
            },
          );
        } catch (discountError) {
          console.error(discountError);
        }
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
